"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const opentracing_1 = require("opentracing");
exports.Tracer = opentracing_1.Tracer;
exports.Span = opentracing_1.Span;
class LogSpan extends opentracing_1.Span {
    constructor(name, logger, opts = {}) {
        super();
        this.name = name;
        this.logger = logger;
        this.startTime = Date.now();
        const tags = opts.tags || {};
        tags.span = name;
        const parent = opts.references && opts.references[0];
        if (parent != null && parent.referencedContext() instanceof LogSpan) {
            this.parent = parent.referencedContext();
        }
        this.tags = tags || {};
        if (this.parent) {
            this.logger.debug().log({
                msg: this.familyTree().join(" => ")
            });
        }
    }
    familyTree() {
        const ancestors = [];
        let parent = this;
        while (parent.parent != null) {
            ancestors.unshift(parent.name);
            parent = parent.parent;
        }
        return ancestors;
    }
    _context() {
        return this;
    }
    //  protected _tracer(): Tracer {}
    //  protected _setOperationName(name: string): void;
    //  protected _setBaggageItem(key: string, value: string): void;
    //  protected _getBaggageItem(key: string): string | undefined;
    _addTags(keyValuePairs) {
        this.tags = Object.assign({}, this.tags, keyValuePairs);
    }
    _log(keyValuePairs, _timestamp) {
        const l = keyValuePairs.error || this.tags.error
            ? this.logger.error()
            : this.logger.info();
        l.with(this.tags).log(Object.assign({}, keyValuePairs, { msg: keyValuePairs.msg || keyValuePairs["error.description"] }));
    }
    _finish(finishTime) {
        finishTime = finishTime || Date.now();
        const duration_us = 1000 * (finishTime - this.startTime);
        this.logger.info().log({
            duration_us,
            msg: `(${duration_us / 1000}ms) ` + this.familyTree().join(" <= ")
        });
    }
}
class LogTracer extends opentracing_1.Tracer {
    constructor(logger) {
        super();
        this.logger = logger.with({ context: "tracing" });
    }
    _startSpan(name, opts) {
        return new LogSpan(name, this.logger, opts);
    }
}
exports.LogTracer = LogTracer;
const markSpanError = (span) => (err) => {
    span.setTag(opentracing_1.Tags.ERROR, true);
    span.log({
        error: err.toString()
    });
    span.finish();
    throw err;
};
exports.markSpanError = markSpanError;
const noopTracer = new opentracing_1.Tracer();
exports.noopTracer = noopTracer;
__export(require("./context"));
//# sourceMappingURL=index.js.map